export default {
  "content": "<path d=\"M10 10.5H7.75a.25.25 0 00-.25.25v2.5c0 .138.112.25.25.25h.75v-2H10V15H7.75A1.75 1.75 0 016 13.25v-2.5C6 9.784 6.784 9 7.75 9H10v1.5zM12.75 15h-1.5V9h1.5v6zM18 10.5h-2.5v1h2V13h-2v2H14V9h4v1.5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5 3.5a1 1 0 011 1v15a1 1 0 01-1 1h-19a1 1 0 01-1-1v-15a1 1 0 011-1h19zm-18 15h17v-13h-17v13z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};